import sdkProvider from "../../../../client/sdkProvider";
import logger from "../../../../lib/logger";
import getEnableComplianceVariantFromConfig from "../selectors/getEnableComplianceVariantFromConfig";
import setEnableComplianceVariant from "./setEnableComplianceVariant";

const loadEnableComplianceVariant = () => async dispatch => {
  try {
    const loyaltySdk = await sdkProvider("loyalty");
    const config = await loyaltySdk.getConfig();
    const isEnabled = getEnableComplianceVariantFromConfig(config);

    dispatch(setEnableComplianceVariant(isEnabled));
  } catch (error) {
    if (error.name !== "LoyaltyNotSupportedError") {
      error.message = `loadEnableComplianceVariant failed with error: ${error.message}`;
      logger.error(error);
    }
  }
};

export default loadEnableComplianceVariant;
